<script lang="ts">
    import { faEdit, faEye } from '@fortawesome/free-solid-svg-icons'
    import type { Entry } from '../../../modules/financialApi/entries/entry'
    import { EntryTypeEnum } from '../../../modules/financialApi/entries/entry.enum'
    import Popover from '../../_common/popover.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Financial_4AccountsForm from './../accounts/financial-4-accounts-form.svelte'
    import { createEventDispatcher, onMount } from 'svelte'
    import { ChartData } from '../../_common/z/zchart'
    import Zchart from '../../_common/z/zchart.svelte'
    const dispatch = createEventDispatcher()

    export let entries: Entry[] = []

    let loaded = false
    onMount(() => {
        loaded = true
    })

    $: {
        if (loaded) {
            loadGridCat(entries)
        }
    }

    let gridCat: GridClass = new GridClass()
    function loadGridCat(entries: Entry[]) {
        // grid
        gridCat = new GridClass()
        // grid head
        gridCat.title = 'Categorias'
        gridCat.subtitle = ''
        gridCat.fontSize = '14px'
        gridCat.showActs = false
        gridCat.cols.push(new GridCol({ content: 'Categoria', type: GridColTypeEnum.string, maxLength: 110 }))
        gridCat.cols.push(new GridCol({ content: 'Valor', type: GridColTypeEnum.float_2, showTotal: true }))
        gridCat.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))

        let cats: { label: string; value: number; categoryId: string }[] = []
        for (const item of entries) {
            let found = cats.find((el) => el.categoryId === item.categoryId)
            if (!found) {
                found = {
                    label: item.category?.label,
                    categoryId: item.categoryId,
                    value: 0,
                }
                cats.push(found)
            }
            found.value += item.value
        }
        for (const item of cats) {
            const btnOpen = new GridButton({
                callback: () => {
                    showDetails(item.categoryId)
                },
                icon: faEye,
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.label })
            line.slots.push({ content: item.value })
            line.slots.push({ content: [btnOpen] })
            gridCat.lines.push(line)
        }
        if (cats.length > 0) {
            loadGrid(entries, cats[0].categoryId)
        }
    }

    function showDetails(categoryId: string) {
        loadGrid(entries, categoryId)
    }

    let grid: GridClass = new GridClass()
    function loadGrid(entities: Entry[], categoryId: string) {
        if (!entities) entities = []
        // grid
        grid = new GridClass()
        // grid head
        grid.title = entries.find((el) => el.categoryId === categoryId)?.category?.label || 'Detalhamento'
        grid.subtitle = ''
        grid.fontSize = '14px'
        grid.showActs = false
        grid.cols.push(new GridCol({ content: 'Data da compensação', type: GridColTypeEnum.date }))
        if (window.configs.financialShowAccrual) {
            grid.cols.push(new GridCol({ content: 'Competência', type: GridColTypeEnum.string }))
        }
        grid.cols.push(new GridCol({ content: 'Conta', type: GridColTypeEnum.string, maxLength: 30 }))
        //grid.cols.push(new GridCol({ content: 'Credor/pagador', type: GridColTypeEnum.string, maxLength: 45 }))
        grid.cols.push(new GridCol({ content: 'Descrição', type: GridColTypeEnum.string, maxLength: 90 }))
        grid.cols.push(new GridCol({ content: 'Valor', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            if (item.categoryId !== categoryId) continue
            const btnOpen = new GridButton({
                callback: () => goshowForm(item.entryId, item.type),
                icon: faEdit,
                label: 'Editar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.paymentAt })
            if (window.configs.financialShowAccrual) {
                line.slots.push({ content: item.accrualMonth ? `${item.accrualMonth}/${item.accrualYear}` : item.accrualYear })
            }
            line.slots.push({ content: item.account?.label })
            //line.slots.push({ content: item.person?.name || '-' })
            line.slots.push({ content: item.description || '' })
            line.slots.push({ content: item.type === EntryTypeEnum.credit ? item.value : item.value * -1 })
            line.slots.push({ content: [btnOpen] })
            grid.lines.push(line)
        }

        loadChart(categoryId)
    }

    let showForm = false
    let entryId: string = null
    let creditDebit: EntryTypeEnum = null
    function goshowForm(id: string, _creditDebit: EntryTypeEnum) {
        creditDebit = _creditDebit
        entryId = id
        showForm = true
    }

    function formChanged() {
        dispatch('change')
        showForm = false
    }
    function formCanceled() {
        showForm = false
    }

    let chart: ChartData
    function loadChart(categoryId: string) {
        if (!entries) entries = []
        chart = new ChartData()
        let items: { label: string; value: number }[] = []
        for (const el of entries) {
            if (el.categoryId !== categoryId) continue
            items.push({
                label: el.description?.length > 30 ? el.description.substring(0, 27) + '...' : el.description,
                value: el.value,
            })
        }
        items.sort(window.api.utils.utils.dynamicSortMultiple(false, 'value')).reverse()
        chart.categories = [...items.map((el) => el.label || '')]
        chart.type = 'donut'
        chart.title = entries.find((el) => el.categoryId === categoryId)?.category?.label || 'Detalhamento'
        chart.series = [...items.map((el) => el.value)]

        chart = chart
    }
</script>

{#if showForm}
    <Popover title="Editar lançamento" width="1100px" height="360px" on:close={formCanceled}>
        <Financial_4AccountsForm {entryId} {creditDebit} on:change={formChanged} />
    </Popover>
{/if}

<div>
    <Zgrid grid={gridCat} class="m-3 mb-0" />
    <Zgrid {grid} class="m-3 h-space" />
    <Zchart data={chart} class="m-3 h-space"></Zchart>
</div>

<style>
</style>
